<template>
  <section>
    <b-field
      :label="$t('C023_10')"
      :message="
        $v.selectedAddress.receiverName.$error
          ? $v.selectedAddress.receiverName.required
            ? $t('EF2052_Content')
            : $t('EF2051_Content')
          : ''
      "
      :type="$v.selectedAddress.receiverName.$error ? 'is-danger' : ''"
    >
      <b-custom-input
        ref="receiverName"
        v-model="selectedAddress.receiverName"
        :placeholder="$t('C023_11')"
        @blur="$v.selectedAddress.receiverName.$touch"
      />
    </b-field>
    <div class="columns">
      <div class="column is-half">
        <b-field
          :label="$t('C023_12')"
          :message="
            $v.selectedAddress.zipcode.$error
              ? $v.selectedAddress.zipcode.required
                ? $t('EF2010_Content')
                : $t('EF2053_Content')
              : ''
          "
          :type="$v.selectedAddress.zipcode.$error ? 'is-danger' : ''"
        >
          <b-custom-input
            ref="zipcode"
            v-model="selectedAddress.zipcode"
            :placeholder="$t('C023_13')"
            mask="111-1111"
            style="width: 120px"
            @blur="$v.selectedAddress.zipcode.$touch"
          />
        </b-field>
      </div>
      <div class="column is-half">
        <div class="text-postcode">
          <a href="http://www.post.japanpost.jp/zipcode/" class="line-height40 extra-link" target="_blank"
            >{{ $t('C005_7') }}
            <b-icon pack="fas" icon="external-link-alt" size="is-small" />
          </a>
        </div>
      </div>
    </div>
    <b-field
      :label="$t('C023_15')"
      :message="$v.selectedAddress.prefectureId.$error ? $t('EF2055_Content') : ''"
      :type="$v.selectedAddress.prefectureId.$error ? 'is-danger' : ''"
    >
      <b-select
        v-model="selectedAddress.prefectureId"
        :placeholder="$t('C023_16')"
        expanded
        @blur="$v.selectedAddress.prefectureId.$touch"
      >
        <optgroup v-for="group in $t('areas')" :label="group.name" :key="group.id">
          <option v-for="item in group.prefectures" :value="group.id + '_' + item.id" :key="item.id">
            {{ item.name }}
          </option>
        </optgroup>
      </b-select>
    </b-field>

    <b-field
      :label="$t('C005_10')"
      :message="
        $v.selectedAddress.address.$error
          ? $v.selectedAddress.address.required
            ? $t('EF2011_Content')
            : $t('EF2056_Content')
          : ''
      "
      :type="$v.selectedAddress.address.$error ? 'is-danger' : ''"
    >
      <b-custom-input
        ref="address"
        v-model="selectedAddress.address"
        :placeholder="$t('C005_11')"
        @blur="$v.selectedAddress.address.$touch"
      />
    </b-field>

    <b-field
      :label="$t('C023_19')"
      :message="
        $v.selectedAddress.phoneNumber.$error
          ? $v.selectedAddress.phoneNumber.required
            ? $t('EF2059_Content')
            : $t('EF2058_Content')
          : ''
      "
      :type="$v.selectedAddress.phoneNumber.$error ? 'is-danger' : ''"
    >
      <b-custom-input
        ref="phoneNumber"
        v-model="selectedAddress.phoneNumber"
        :placeholder="$t('C023_20')"
        type="number"
        @blur="$v.selectedAddress.phoneNumber.$touch"
      />
    </b-field>

    <div v-if="isOrderProcess" class="field">
      <b-checkbox v-model="selectedAddress.saveRecord" type="is-primary">{{ $t('C023_21') }}</b-checkbox>
    </div>
    <br />
    <button v-if="this.$route.params.id" class="button is-primary" @click="onSubmit">{{ $t('C054_1') }}</button>
    <button v-else class="button is-primary" @click="onSubmit">{{ $t('S003_22') }}</button>
    <div><b-loading :is-full-page="true" :can-cancel="false" /></div>
  </section>
</template>
<style lang="scss" src="./address-form.scss">
</style>

<script>
import BCustomInput from '@/components/common/b-custom-input/b-custom-input.vue';
import { validationMixin } from 'vuelidate';
import required from 'vuelidate/src/validators/required';
import maxLength from 'vuelidate/src/validators/maxLength';
import minLength from 'vuelidate/src/validators/minLength';
import { isCodeNumber } from '../../../../utils/validateUtil';
import { getDeliveryAddressInfo } from '../../../../services/profile.service';

export default {
  name: 'AddressForm',
  components: {
    'b-custom-input': BCustomInput
  },
  mixins: [validationMixin],
  validations: {
    selectedAddress: {
      receiverName: {
        required,
        maxLength: maxLength(30)
      },
      prefectureId: {
        required
      },
      zipcode: {
        required,
        isCodeNumber
      },
      address: {
        required,
        maxLength: maxLength(100)
      },
      phoneNumber: {
        required,
        maxLength: maxLength(11),
        minLength: minLength(10)
      }
    }
  },
  props: {
    isOrderProcess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedAddress: {
        id: null,
        prefectureId: null,
        saveRecord: false,
        receiverName: '',
        zipcode: '',
        address: '',
        phoneNumber: '',
        prefecture: ''
      }
    };
  },
  async mounted() {
    this.loading++;
    if (this.$route.params.id) {
      this.selectedAddress.id = this.$route.params.id;
      let shipAddress = await getDeliveryAddressInfo();
      if (shipAddress.status) {
        shipAddress.result.data.forEach(address => {
          if (address.id == this.selectedAddress.id) {
            this.selectedAddress.receiverName = address.receiverName;
            this.selectedAddress.zipcode = address.zipcode;
            this.selectedAddress.phoneNumber = address.phoneNumber;
            this.selectedAddress.address = address.address;
            this.$t('areas').forEach((group, index1) => {
              group.prefectures.forEach((prefecture, index2) => {
                if (prefecture.name === address.prefecture) {
                  this.selectedAddress.prefectureId = index1 + '_' + index2;
                }
              });
            });
          }
        });
      }
    }
    this.loading--;
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const areas = this.$t('areas');
        const indexes = this.selectedAddress.prefectureId.split('_');
        if (indexes[0] && indexes[1]) {
          this.selectedAddress.prefecture = areas[indexes[0]].prefectures[indexes[1]].name;
        }
        this.$emit('onSubmit', this.selectedAddress);
      }
    }
  }
};
</script>
